// extracted by mini-css-extract-plugin
export default {"balance":"Balance_balance__JZxt+","fractionalPart":"Balance_fractionalPart__XbFKd","icon":"Balance_icon__hMzVa"};